import {
  Checkbox,
  Flex,
  Heading,
  Box,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import CommonAutocomplete from "../shared/CommonAutocomplete";

export default function FilterSection() {
  const initialValues = {
    category: ["Logo Design", "Stationery Design", "Brochure Design"],
    skills: ["Graphic Design", "PHP", "HTML", "CSS"],
  };
  return (
    <Stack
      p={{ base: "0px 4px", md: 5 }}
      border={{ base: 0, xl: "1px solid #C5C5C5" }}
      borderRadius={10}
      mb={{ base: 0, md: 10 }}
      height="fit-content"
      bgColor="white"
    >
      <Heading
        color="#727272"
        fontWeight={"medium"}
        fontSize="22px"
        pb={10}
        display={{ base: "none", md: "block" }}
      >
        Filter By
      </Heading>
      <Stack gap={2} py={6}>
        <Heading fontWeight="semibold" fontSize="18">
          Category
        </Heading>
        {initialValues.category.map((item,index) => (
          <Checkbox borderColor="brand.500"  colorScheme="brand" key={index}>{item}</Checkbox>
        ))}
        <Box py={2}>
          <CommonAutocomplete
            placeholder="Search Category..."
            options={["Graphic Design", "Web Development"]}
            // handleClick={()=>{}}
          />
        </Box>
      </Stack>
      {/* Budget Section */}
      <Stack gap={2} py={6}>
        <Heading fontWeight="semibold" fontSize="18">
          Budget
        </Heading>
        <Checkbox borderColor="brand.500"  colorScheme="brand">Fixed Price Projects</Checkbox>
        <Flex gap={4} w="full" alignItems="center">
          <Input placeholder="MIN" w="75px" type="number" _placeholder={{color:"brand.500",fontWeight:"medium"}} />
          <Text>To</Text>
          <Input placeholder="MAX" w="75px" type="number" _placeholder={{color:"brand.500",fontWeight:"medium"}} />
        </Flex>
      </Stack>
      <Stack gap={2} py={6}>
        <Heading fontWeight="semibold" fontSize="18">
          Type
        </Heading>
        <Checkbox borderColor="brand.500"  colorScheme="brand">Featured Jobs</Checkbox>
        <Checkbox borderColor="brand.500"  colorScheme="brand">Full Time Jobs</Checkbox>
      </Stack>
      <Stack gap={2} py={6}>
        <Heading fontWeight="semibold" fontSize="18">
          Skills
        </Heading>
        <Checkbox borderColor="brand.500"  colorScheme="brand">Graphic Design</Checkbox>
        <Checkbox borderColor="brand.500"  colorScheme="brand">PHP</Checkbox>
        <Checkbox borderColor="brand.500"  colorScheme="brand">CSS</Checkbox>
        <Checkbox borderColor="brand.500"  colorScheme="brand">HTML</Checkbox>
        <Box py={2}>
          <CommonAutocomplete
            placeholder="Search Skills..."
            options={[
              "Graphic Design",
              "PHP",
              "CSS",
              "HTML",
              "Web Development",
            ]}
          />
        </Box>
      </Stack>
      <Stack gap={2} py={6}>
        <Heading fontWeight="semibold" fontSize="18">
          Language
        </Heading>
        <Checkbox borderColor="brand.500"  colorScheme="brand">English</Checkbox>
        <Checkbox borderColor="brand.500"  colorScheme="brand">Spanish</Checkbox>
        <Checkbox borderColor="brand.500"  colorScheme="brand">German</Checkbox>
        <Checkbox borderColor="brand.500"  colorScheme="brand">French</Checkbox>
        <Box py={2}>
          <Input placeholder="Search Language..." />
        </Box>
      </Stack>
    </Stack>
  );
}
